	export enum ErpSystemEnum {
		Apprise = 1,
		BusinessCentral = 2
	}
